<script setup lang="ts">
import { ref, h, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { menuKeyForPath } from '../layout'
import {
  NLayout, NLayoutSider, NLayoutHeader, NLayoutContent,
  NMenu, NButton, NSpace, NText, NIcon, type MenuOption,
} from 'naive-ui'
import {
  ServerOutline, SettingsOutline,
} from '@vicons/ionicons5'
import { message } from '../message'
import { logout, me } from '../api'

const router = useRouter()
const route = useRoute()
const username = ref<string | null>(null)

me().then(u => { if (u) username.value = u.username })

function icon(comp: any) {
  return () => h(NIcon, null, { default: () => h(comp) })
}

const menuOptions: MenuOption[] = [
  { label: '服务 Services', key: 'services', icon: icon(ServerOutline) },
  { label: '系统 System', key: 'system', icon: icon(SettingsOutline) },
]

const activeKey = computed(() => menuKeyForPath(route.path))

function navigate(key: string) {
  if (key === 'services') router.push('/')
  else if (key === 'system') router.push('/system')
}

async function doLogout() {
  await logout()
  message.success('Signed out')
  router.push('/login')
}
</script>

<template>
  <NLayout has-sider style="min-height: 100vh">
    <NLayoutSider bordered :width="200" :native-scrollbar="false" style="background: #fff">
      <div style="padding: 18px 20px; font-weight: 700; font-size: 15px; white-space: nowrap; overflow: hidden; border-bottom: 1px solid rgb(239, 239, 245)">
        Services Manager
      </div>
      <NMenu :value="activeKey" :options="menuOptions" @update:value="navigate" />
    </NLayoutSider>

    <NLayout>
      <NLayoutHeader bordered style="height: 48px; display: flex; align-items: center; justify-content: flex-end; padding: 0 24px; background: #fff">
        <NSpace align="center">
          <NText depth="3" style="font-size: 13px">{{ username }}</NText>
          <NButton size="small" text @click="doLogout">退出登录</NButton>
        </NSpace>
      </NLayoutHeader>

      <NLayoutContent :native-scrollbar="false" content-style="padding: 24px">
        <slot />
      </NLayoutContent>
    </NLayout>
  </NLayout>
</template>
